import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import { useRequisitionInfo } from 'hooks/drawers/useRequisitionInfo'
import { getNextAppointment } from 'controllers/TaskManager/controllers/utils'
import TaskRefusalController from 'controllers/TaskManager/TaskSubControllers/TaskRefusalController/TaskRefusalController'
import InfoList from 'components/InfoList/InfoList'
import ExpandableWidget from 'components/ExpandableWidget/ExpandableWidget'
import MedicalActsList from 'components/MedicalActsList/MedicalActsList'
import { RequisitionType } from 'utils/enums'

import styles from '../../Requisition.module.sass'

const MedicalActsRequisitionDetails = (props) => {
	const { requisition } = props
	const { i18n } = useGlobal()

	const {
		getMedicalActsDetails,
		getMedicalActsListDetails,
		getPhysiotherapyDetails,
	} = useRequisitionInfo(requisition, i18n)

	const nextAppointment = getNextAppointment(requisition?.appointments)
	const medicalActsListDetails = getMedicalActsListDetails()
	const isPhysiotherapy =
		requisition?.type?.id === RequisitionType.Physiotherapy

	return (
		<>
			<section>
				<TaskRefusalController requisition={requisition} />

				{requisition?.clinicalObservation ? (
					<InfoList
						className={styles['info-list']}
						items={[
							{
								title: i18n`Medical observation`,
								text: requisition?.clinicalObservation,
								icon: 'observation',
							},
						]}
					/>
				) : null}
			</section>

			<section>
				<InfoList
					className={styles['info-list']}
					items={getMedicalActsDetails(nextAppointment)}
				/>
			</section>

			{medicalActsListDetails.length ? (
				<section>
					<MedicalActsList
						items={medicalActsListDetails}
						title={i18n`Medical Acts`}
						subtitle={i18n`Laterality | Quantity`}
						displayListLength
					/>
				</section>
			) : null}

			{isPhysiotherapy && (
				<section>
					<ExpandableWidget
						className={styles['additional-data-container']}
						heading='h5'
						title={i18n`Additional data`}
						expanded={true}
					>
						<InfoList
							className={styles['info-list']}
							items={getPhysiotherapyDetails(nextAppointment)}
							orientation='horizontal'
						/>
					</ExpandableWidget>
				</section>
			)}
		</>
	)
}

export default MedicalActsRequisitionDetails
